import { Link } from 'react-router-dom';
import { getDiscount } from '../../utils/functions';
import DeleteIcon from '@mui/icons-material/Delete';
import StarIcon from '@mui/icons-material/Star';
import { removeFromWishlist } from '../../actions/wishlistAction';
import { useDispatch } from 'react-redux';
import {
    Box,
    Typography,
    Paper,
    Grid,
    useTheme,
    styled,
    IconButton,
    Tooltip,
} from '@mui/material';

const HoverPaper = styled(Paper)(({ theme }) => ({
    transition: theme.transitions.create(['transform', 'box-shadow'], {
        duration: theme.transitions.duration.enteringScreen,
    }),
    '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: theme.shadows[8],
    },
}));

const Product = (props) => {
    const { product, name, price, cuttedPrice, image, ratings, reviews } = props;
    const dispatch = useDispatch();
    const theme = useTheme();

    const deleteHandler = (e) => {
        e.preventDefault();
        dispatch(removeFromWishlist(product));
    };

    return (
        <HoverPaper
            elevation={2}
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                borderRadius: 2,
            }}
        >
            <Link to={`/product/${product}`} style={{ textDecoration: 'none' }}>
                <Box
                    component="img"
                    src={image}
                    alt={name}
                    sx={{
                        width: '100%',
                        height: 140,
                        objectFit: 'contain',
                        borderTopLeftRadius: theme.shape.borderRadius,
                        borderTopRightRadius: theme.shape.borderRadius,
                        p: 1,
                    }}
                />
                <Box sx={{ p: 2 }}>
                    <Typography
                        variant="subtitle1"
                        noWrap
                        title={name}
                        sx={{ fontWeight: 500, color: 'text.primary' }}
                    >
                        {name}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', my: 1 }}>
                        <StarIcon sx={{ fontSize: '1rem', mr: 0.5, color: '#FFC107' }} />
                        <Typography variant="body2" color="text.secondary">
                            {ratings} ({(reviews || 0).toLocaleString()} reviews)
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="h6" component="div" sx={{ mr: 1 }}>
                            ₹{(price || 0).toLocaleString()}
                        </Typography>
                        {cuttedPrice > price && (
                            <>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ textDecoration: 'line-through', mr: 1 }}
                                >
                                    ₹{cuttedPrice.toLocaleString()}
                                </Typography>
                                <Typography variant="body2" color="success.main">
                                    {getDiscount(price, cuttedPrice)}% off
                                </Typography>
                            </>
                        )}
                    </Box>
                </Box>
            </Link>
            <Box sx={{ p: 1, textAlign: 'right' }}>
                <Tooltip title="Remove from wishlist" arrow>
                    <IconButton onClick={deleteHandler} aria-label="delete from wishlist">
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </HoverPaper>
    );
};

export default Product;
